import React from "react";
import { observer } from "mobx-react";
import styled from "styled-components";
import chroma from "chroma-js";

import blockStore, { ascendants, block, selectBlock } from "../canvas/store";

import * as Colors from "../reusable/colors";
import { VCenter } from "../reusable/layout";

const Breadcrumb = styled.div`
  display: flex;
  background-color: ${Colors.secondary}
  height: 35px;
`;

const BreadItem = styled.div`
  padding: 5px 15px;
  border-right: 1px solid
    ${chroma(Colors.secondary)
      .darken(0.6)
      .hex()};
  color: ${Colors.secondary};
  height: 100%;
  ${VCenter};
  cursor: pointer;
  font-weight: ${p => (p.selected ? "bold" : "normal")};
  &:hover {
    background-color: ${chroma(Colors.secondary)
      .darken(0.2)
      .hex()};
    color: ${Colors.Text};
  }
`;

const BreadCr = p => {
  return (
    <Breadcrumb>
      {ascendants(blockStore.selected).map(p => (
        <BreadItem key={p} onClick={() => selectBlock(p)} selected={p === blockStore.selected}>
          {block(p).label}
        </BreadItem>
      ))}
    </Breadcrumb>
  );
};

export default observer(BreadCr);



// WEBPACK FOOTER //
// ./src/canvas/breadcrumb.js